import { render, staticRenderFns } from "./ImageShow.vue?vue&type=template&id=0c2cfed2&scoped=true"
import script from "./ImageShow.vue?vue&type=script&lang=js"
export * from "./ImageShow.vue?vue&type=script&lang=js"
import style0 from "./ImageShow.vue?vue&type=style&index=0&id=0c2cfed2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c2cfed2",
  null
  
)

export default component.exports